/* -------------------------- */
/* Theme custom JavaScript.   */
/* -------------------------- */

!function($) {

    // Document ready
    $(function() {
      
      // Only call these functions on product page
      if ( $('html').hasClass('template-product') ){

        // Re-arrange product info to tabs on product page
        productTabs();

        // Show and hide product pictures
        toggleProductPictures(); 

        // Force user to first select size. See also template-product.js and component-product-form.js
        productSizeChanges(); 

      }

      // MyHalti Product Search
      myHaltiProductSearch(); 

    });

  // Functions
  function productTabs() {
    
      // Create variables for tabs content
      $features = $('.tabs-content #tab1').children();
      $materials = $('.tabs-content #tab2').children();
      $size = $('.tabs-content #tab3').children();
      
      // Some products don't have instructions
      if ( $('.tabs-content #tab4').length > 0 ) {
          $instructions = $('.tabs-content #tab4').children();
          $('.tab-instructions .tab-content__inner').append($instructions);
      } else {
          $('.tab-instructions').remove();
      }
      
      // Add content to new tabs
      $('.tab-features .tab-content__inner').append($features);
      $('.tab-materials .tab-content__inner').append($materials);
      $('.tab-size .tab-content__inner').append($size);

      // Remove description header
      $('.product__description h2').remove();
      
      // Description as tab is optionary 
      if ( $('.tab-description').length > 0 ) {
          $description = $('.product__description').children().not('.tabs,.tabs-content');
          $('.tab-description .tab-content__inner').append($description);
          $('.product__description').remove();
      } else {
          $('.product__description .tabs, .product__description .tabs-content').remove();
          $('.product__description').removeClass('hidden');
      }
      
      // Add heights for tabs and collapse them
      $('.tab-content').each( function() {
          var height = $(this).outerHeight();
          $(this).data('height', height);
          $(this).css('height', 0);
      });
      
      // Show and hide tabs content on click. 
      $('.description-tabs .tab h3').click( function() {
      
          var $currentTab = $(this).parent();
          
          if ($currentTab.hasClass('active')) {
              $currentTab.toggleClass('active').find('.tab-content').css('height', 0);
          } else {
              var height = $currentTab.find('.tab-content').data('height');
              $currentTab.toggleClass('active').find('.tab-content').css('height', height + 'px');
          }
      
      });
  
    }

    function toggleProductPictures() {

      // jQuery objects
      $picturesButton = $('.gridy-slider.product-media-slider #show-product-pictures');
      $productMedia = $('.gridy-slider.product-media-slider .product-media:nth-child(n+5)');
      
      // Event handler for pictures button clicks
      $picturesButton.click(function() {

        // Show additional pictures if they are hidden
        if ( $picturesButton.text() == 'Show more' ) {
          $picturesButton.text('Show less');
          $('gridy-slider .button-container').addClass('active');
          $productMedia.addClass('visible');
        } else {
          // Hide additional pictures if they are visible
          $productMedia.removeClass('visible');
          $picturesButton.text('Show more');
          $('gridy-slider .button-container').removeClass('active');
          let rect = $('gridy-slider')[0].getBoundingClientRect();
          window.scroll('',rect.y);
        }
        
      });

      // Event handler for color change
      $('variant-radios fieldset[data-option="Color"] input[type="radio"]:nth-of-type(n+2)').click(function() {

          // Show additional pictures if picture for active color is hidden
          const activeColor = $(this).val().split(' ')[0]; 
          const activeColorIsHidden = $('.gridy-slider.product-media-slider .product-media').slice(0,4).find('img').toArray().some(img => 
            $(img).attr('srcset') && !$(img).attr('srcset').includes(activeColor)
          );

          if ( activeColorIsHidden ) {
            $picturesButton.text('Show less');
            $productMedia.addClass('visible');
            setTimeout(function() {
              $('gridy-slider .button-container').addClass('active');
            }, 500);
          }
        
      });
 
    }

    function myHaltiProductSearch() {

      $('#myhalti-search').submit(function(e) {
      
        // Prevent the default form submission
        e.preventDefault(); 
        
        // Get the product code from the form and sanitize it
        var productCode = sanitizeInput($('form #product-code').val()); 
        
        // Fetch the data from the server
        fetch('https://myhalti.konsepto.fi/api', {
        
          // Define the request method, headers and body
          method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            productCode: `${productCode}`
          })
        })
          
          // Parse the response
          .then(response => response.json())
            
          // Add the data to the page
          .then(results => {

            // If matching row is found
            if ( results.status === 'Success') {
  
              // Make sure that product details container is empty
              $('#product-details').empty(); 
  
              // Add the start of an unordered list
              $('#product-details').append('<ul>');            
  
              // Add each product feature as list item
              Object.entries(results.data).forEach(([key, value]) => {
                  $('#product-details ul').append(`<li><strong>${key}</strong> ${value}`);
              });
  
              // Add the end of an unordered list
              $('#product-details').append('</ul>');   
              
            } else {

              // Make sure that product details container is empty
              $('#product-details').empty(); 

              // Append an error message
              $('#product-details').append(results.message);   
              
            }

          })
            
          // Log any errors
          .catch((error) => {
            
            console.error('Error:', error);
          
          });

      });
      
    }

    function sanitizeInput(input) {

      // Basic sanitization: remove script tags and potentially harmful characters
      const sanitized = input
        
        .replace(/<script.*?>.*?<\/script>/gi, '')  // Remove script tags
        .replace(/<[^\>]*>/g, '')                  // Remove any remaining HTML tags
        .replace(/&/g, '&amp;')                    // Escape ampersand
        .replace(/</g, '&lt;')                     // Escape less than
        .replace(/>/g, '&gt;')                     // Escape greater than
        .replace(/"/g, '&quot;')                   // Escape double quote
        .replace(/'/g, '&#39;');                   // Escape single quote

      return sanitized;

    }

  function productSizeChanges() {

    // Click event handler for size radio inputs
    $(document).on('click', 'variant-radios input[name="Size"]', function () {

      // If default size is in use, set 
      if (this.checked == true) {
        $('fieldset[data-option="Size"] legend strong').text($(this).val());
      }

      // Set default size data attribute to false as user has now selected a size
      document.querySelector('variant-radios').setAttribute('data-default-size','false');

      // If size error is visible, hide it
      if ($('.product-form__error-message-wrapper').is(':visible') && $('.product-form__error-message').text() == 'Choose a size first') {
        $('product-form')[0].handleErrorMessage();
      }

    });

  }


}(jQuery);